import type { SubscriptionPricingState } from './recurly/subscription-pricing'

const readablePriceWithDuration = (price: SubscriptionPricingState, isAnnualPlan: boolean) => {
  if (isAnnualPlan) {
    // Annual, "Single use" coupon
    if (price.now.total !== price.next.total) {
      return `${price.currency.symbol}${price.now.total} for your first year and ${price.currency.symbol}${price.next.total} per year after`
    }
    // Annual, "Forever" coupon
    return `${price.currency.symbol}${price.now.total} per year`
  }
  // Monthly, "Single use" coupon
  if (price.now.total !== price.next.total) {
    return `${price.currency.symbol}${price.now.total} for your first month and ${price.currency.symbol}${price.next.total} per month after`
  }
  // Monthly, "Forever" coupon
  return `${price.currency.symbol}${price.now.total} per month`
}

export const renderDisclaimerText = (price: SubscriptionPricingState, buttonText: string, isAnnualPlan: boolean) =>
  `By clicking ${buttonText}, you agree to our Terms of Service and Privacy Policy. PFF is an ongoing subscription. You will be charged ${readablePriceWithDuration(
    price,
    isAnnualPlan
  )}. You may be subject to tax. Cancel anytime.`

export const getDiscountPercent = (discountedPrice: number, originalPrice: number) => {
  return Math.trunc(((originalPrice - discountedPrice) / originalPrice) * 100)
}

export function getCancelationDescription(expirationDate: string) {
  const expirationDateForDescription = expirationDate ? ` on ${expirationDate}` : ''
  const description1 = `Canceling your PFF+ subscription means you'll change to our free membership${expirationDateForDescription}.`
  const description2 = `You'll lose all your PFF+ premium benefits, including access to personalized and exclusive PFF data and insights.`
  return `${description1} ${description2}`
}
